import url from '@/shared/api/parametre'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    // current_user: JSON.parse(localStorage.getItem('userData')),
    count_message_unread: 0,
    isPaginate: false,
    paginateRequest: {
      FD: 'R', // Text value of message direction (Envoyé / reçu). Default value is "Reçue".
      FT: 'A', // Text value of filter type (A / Réseaux / Clients / Assureurs / Comptabilité). Default value is "A". "A" is Tous.
      C: 50 , // Numeric value of the maximum number of messages to retrieve. Default value is 50.
      FR: 'A', // Text value of message read status (Lire / Non lus / Tous). Default value is "Tous".
      FP: 'R', // Text value of message order (Récent / ancien). Default value is "Récente".
      S: null, // Text value of message order (text chercher).
    },
    paginateResult: {
      current_page: null,
      last_page: null,
      next_page: null,
      per_page: null
    },
    refresh: false,
  },
  getters: {
    getCountMessageUnread(state) {
      return state.count_message_unread
    },
    getPaginateResult(state) {
      return state.paginateResult
    },
    getPaginateRequest(state) {
      return state.paginateRequest
    },
    getPaginateRequestFP(state) {
      return state.paginateRequest.FP;
    },
    getPaginateResultNextPage(state) {
      return state.paginateResult.next_page;
    },
  },
  mutations: {
    setPaginateResult(state, payload) {
      state.paginateResult.current_page = payload.current_page
      state.paginateResult.last_page = payload.last_page
      state.paginateResult.next_page = payload.next_page
      state.paginateResult.per_page = payload.per_page
    },
    setCountMessageUnread(state, payload) {
      state.count_message_unread = payload
    },
    setIsPaginate(state, payload) {
      state.isPaginate = payload
    },
    setRefresh(state, payload) {
      state.refresh = payload
    },
    setPaginateRequestFD(state, payload) {
      state.paginateRequest.FD = payload.value
      state.paginateRequest.FT = 'A'
    },
    setPaginateRequestFT(state, payload) {
      state.paginateRequest.FT = payload.value
    },
    setPaginateRequestC(state, payload) {
      state.paginateRequest.C = payload.value
    },
    setPaginateRequestFR(state, payload) {
      state.paginateRequest.FR = payload
    },
    setPaginateRequestFP(state, payload) {
      state.paginateRequest.FP = payload
    },
    setPaginateRequestS(state, payload) {
      state.paginateRequest.S = payload
    },
  },
  actions: {
    // update
    updateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/evenements/update_state', {
            user_id: JSON.parse(localStorage.getItem('userData')).id,
            payload
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEmailLabels(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/evenements/change_classification', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // delete
    deleteEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/evenements/delete_email', {
            user_id: JSON.parse(localStorage.getItem('userData')).id,
            payload
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // Add
    sendEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        // Set formData
        const formData = new FormData()

        // Append the rest of your form data
        if (payload.data.subject) formData.append('payload[data][subject]', payload.data.subject)
        if (payload.data.message) formData.append('payload[data][message]', payload.data.message)

        if (payload.data.reclamation_id) formData.append('payload[data][reclamation_id]', payload.data.reclamation_id)
        if (payload.data.sinistre_id) formData.append('payload[data][sinistre_id]', payload.data.sinistre_id)
        if (payload.data.contrat_id) formData.append('payload[data][contrat_id]', payload.data.contrat_id)
        if (payload.data.devis_id) formData.append('payload[data][devis_id]', payload.data.devis_id)

        if (payload.data.tiers) {
          if (payload.data.tiers.name) formData.append('payload[data][tiers][name]', payload.data.tiers.name)
          if (payload.data.tiers.email) formData.append('payload[data][tiers][email]', payload.data.tiers.email)
          if (payload.data.tiers.id_client) formData.append('payload[data][tiers][id_client]', payload.data.tiers.id_client)
          if (payload.data.tiers.type_client) formData.append('payload[data][tiers][type_client]', payload.data.tiers.type_client)
          if (payload.data.tiers.type_personne) formData.append('payload[data][tiers][type_personne]', payload.data.tiers.type_personne)
        }

        for (let i = 0; i < payload.data.to.length; i++) {
          formData.append(`payload[data][to][${i}]`, payload.data.to[i])
        }

        if (payload.data.cc) {
          for (let i = 0; i < payload.data.cc.length; i++) {
            formData.append(`payload[data][cc][${i}]`, payload.data.cc[i])
          }
        }

        if (payload.data.cci) {
          for (let i = 0; i < payload.data.cci.length; i++) {
            formData.append(`payload[data][cci][${i}]`, payload.data.cci[i])
          }
        }

        // Append the attached files
        if (payload.data.attached) {
          for (let i = 0; i < payload.data.attached.length; i++) {
            formData.append(`payload[data][attached][${i}][document_id]`, payload.data.attached[i].document_id)
            formData.append(`payload[data][attached][${i}][document_name]`, payload.data.attached[i].document_name)
            formData.append(`payload[data][attached][${i}][document_taille]`, payload.data.attached[i].document_taille)
            formData.append(`payload[data][attached][${i}][document_path]`, payload.data.attached[i].document_path)
            formData.append(`payload[data][attached][${i}][document_file_name]`, payload.data.attached[i].document_file_name)
            formData.append(`payload[data][attached][${i}][emplacement_document]`, payload.data.attached[i].emplacement_document)
          }
        }

        // Append the new files
        if (payload.data.newFiles) {
          for (let i = 0; i < payload.data.newFiles.length; i++) {
            formData.append(`payload[data][newFiles][${i}][idFamille]`, payload.data.newFiles[i].idFamille)
            formData.append(`payload[data][newFiles][${i}][idType]`, payload.data.newFiles[i].idType)
            formData.append(`payload[data][newFiles][${i}][nom]`, payload.data.newFiles[i].nom)
            formData.append(`payload[data][newFiles][${i}][description]`, payload.data.newFiles[i].description)
            formData.append(`payload[data][newFiles][${i}][file]`, payload.data.newFiles[i].file)
          }
        }
        formData.append('payload[type]', payload.type)
        formData.append('user_id', JSON.parse(localStorage.getItem('userData')).id)
        formData.append('courtier_id', JSON.parse(localStorage.getItem('userData')).courtier_user[0].courtier_id)

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
        axios
          .post('/evenements/send_evenement', formData, config)
          .then(response => resolve(response))
          .catch(error => reject(error))

        // axios
        //   .post('/evenements/send_evenement', {
        //     payload: payload,
        //     user_id: JSON.parse(localStorage.getItem('userData')).id,
        //     courtier_id: JSON.parse(localStorage.getItem('userData')).courtier_user[0].courtier_id,
        //   }, payload.config)
        //   .then(response => resolve(response))
        //   .catch(error => reject(error))
      })
    },

    // fetch
    fetchUsersAndClientContact(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .post('/eca_global/fetch_contact_client_and_user_by_courtie', {
            courtier_id: JSON.parse(localStorage.getItem('userData')).courtier_user[0].courtier_id,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchModelsByCourtier(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/bibliotheque_mail/${JSON.parse(localStorage.getItem('userData')).courtier_user[0].courtier_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async fetchEmails(ctx) {
      let urlFetchEmails = `${url}evenements/messageData?page=${ctx.state.paginateResult.next_page}`
      console.log(ctx.state.isPaginate)
      if (ctx.state.isPaginate) {
        urlFetchEmails = `${url}evenements/messageData?page=${ctx.state.paginateResult.next_page}`
      } else {
        urlFetchEmails = `${url}evenements/messageData`
      }
      return new Promise((resolve, reject) => {
        axios
          .post(urlFetchEmails, {
            user_id: JSON.parse(localStorage.getItem('userData')).id,
            refresh: ctx.state.refresh,
            FD: ctx.state.paginateRequest.FD,
            FT: ctx.state.paginateRequest.FT,
            C: ctx.state.paginateRequest.C,
            FR: ctx.state.paginateRequest.FR,
            FP: ctx.state.paginateRequest.FP,
            S: ctx.state.paginateRequest.S,
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    userHasBoiteEmailSync(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}evenements/userHasBoiteEmailSync`, {
            user_id: JSON.parse(localStorage.getItem('userData')).id,
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })

    },
    fetchContratSinistreDevisReclamationByTier(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}evenements/fetch_contrat_sinistre_devis_reclamation_by_tier`, {
            user_id: JSON.parse(localStorage.getItem('userData')).id,
            payload
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchDocumentClientByTier(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}document/fetch_documents_by_tier`, {
            courtier_user_id: JSON.parse(localStorage.getItem('userData')).courtier_user[0].id,
            payload
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchDocumentCourtier(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}document/fetch_documents_courtier_messagerie`, {
            courtier_id: JSON.parse(localStorage.getItem('userData')).courtier_user[0].courtier_id
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    // other function
    paginateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/email/paginate-email', {
            params: payload,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
